import React from 'react';
import UseCaseTemplate from '@/components/use-cases/UseCaseTemplate';

const summary = [
  'Enterprise governance for enrollment trust signals',
  'Consistent feedback handling across divisions',
  'AI visibility accuracy for prospective audiences'
];

const challenges = [
  {
    title: 'Enrollment impact',
    description: 'Public perception shapes student and parent decisions.'
  },
  {
    title: 'Distributed ownership',
    description: 'Feedback and reviews sit across departments and campuses.'
  },
  {
    title: 'AI inconsistency',
    description: 'AI summaries can be outdated or incorrect without governance.'
  }
];

const pillars = [
  {
    title: 'Reputation Governance',
    description: 'Structured response playbooks and escalation paths.'
  },
  {
    title: 'Visibility Monitoring',
    description: 'Track sentiment and visibility across locations and programmes.'
  },
  {
    title: 'AI Trust Layer',
    description: 'Ensure accurate AI summaries for prospective audiences.'
  }
];

const timeline = [
  {
    title: 'Audit',
    description: 'Assess reputation signals and feedback channels by unit.'
  },
  {
    title: 'Align',
    description: 'Define response standards and escalation ownership.'
  },
  {
    title: 'Monitor',
    description: 'Track sentiment, visibility, and review velocity.'
  },
  {
    title: 'Validate',
    description: 'Verify AI summaries and correct inaccuracies.'
  }
];

const deliverables = [
  'Review response governance',
  'Programme‑level reporting',
  'Escalation and issue management process',
  'AI accuracy checks'
];

const kpis = [
  'Improved average rating and review velocity',
  'Faster response time to priority feedback',
  'Reduced negative visibility for key programmes'
];

const example = {
  title: 'Example: Multi‑campus education provider',
  result:
    'Standardized review responses and monitoring improved sentiment trends while reducing negative visibility within one term.'
};

export default function Education() {
  return (
    <UseCaseTemplate
      seoTitle="Use Case: Education"
      seoDescription="Reputation and visibility programmes for education organisations."
      path="/use-cases/education"
      title="Education"
      subtitle="We help education providers maintain trust signals across markets."
      summary={summary}
      challenges={challenges}
      pillars={pillars}
      timeline={timeline}
      deliverables={deliverables}
      kpis={kpis}
      example={example}
    />
  );
}
